import settings from "@/settings";
import axios from "axios";
import { authService } from "@/services/authService";

class GeoServerService {
    private get authorizationHeaders(): Record<string, string> {
        return authService.getAuthorizationHeader();
    }

    async featureServiceLayerData(url: string): Promise<geoserver.featureService<wfsDataLayer.properties, wfsDataLayer.geometry>> {
        const query = await axios.get(url, {
            headers: { ...this.authorizationHeaders }
        })

        if (query.status === 200) {
            return (query?.data as geoserver.featureService<wfsDataLayer.properties, wfsDataLayer.geometry>) ?? null;
        } else {
            console.error(query.data)
            return null;
        }
    }

    async download(url: string): Promise<string> {
        const query = await axios.get(url, {
            headers: { ...this.authorizationHeaders },
            responseType: 'arraybuffer'
        })

        if (!query || query.status !== 200) {
            console.error(query);
            return null;
        }

        const contentType = `${query.headers["content-type"] || 'application/octet-stream'}`;
        const blob = new Blob([query.data], { type: contentType });
        return window.URL.createObjectURL(blob)
    }

    async downloadPluginWPS(params: geoserver.params, downloadType: string = 'image/tiff'): Promise<string> {

        const replacements = { ...params, downloadType };

        const body = settings.wpsPlugin.xmlConfig.replace(
            /{(\w+)}/gi,
            (placeholderWithDelimiters, placeholderWithoutDelimiters) =>
                replacements[placeholderWithoutDelimiters] || placeholderWithDelimiters
        );

        const query = await axios.post(settings.wpsPlugin.serviceUrl, body, {
            headers: {
                'Content-Type': 'text/xml',
                ...this.authorizationHeaders
            },
            responseType: 'arraybuffer'
        })

        if (!query || query.status !== 200) {
            console.error(query);
            return null;
        }

        const contentType = `${query.headers["content-type"] || 'application/octet-stream'}`;
        const blob = new Blob([query.data], { type: contentType });
        return window.URL.createObjectURL(blob)
    }
}
export const geoServerService = new GeoServerService();